export const cookieConsent = {
  cookieConsentTitle: "Cookies y privacidad",
  cookieConsentMessage: "Usamos cookies y tecnologías similares para mejorar tu experiencia y medir el uso del sitio.",
  cookieConsentAcceptBtn: "Aceptar",
  cookieConsentRejectBtn: "Rechazar",
};
